<template>
	<div class="passback">
		<el-container>
			<el-header :style="{'height': headHeight + 'px'}">
				<elheader></elheader>
			</el-header>
			<el-main :style="{'min-height': mainHeight + 'px'}">
				<div class="loginForm">
					<div class="formBox">
						<div class="form">
							<h3 class="title">找回密码</h3>
							<ul>
								<li class="pl95 phone_li">
									<i class="iconfont icon-shouji1"></i>
									<span>+86</span>
									<input type="text" v-model="phone"   placeholder="11位手机号">
								</li>
								<li class="pl40 pr120">
									<i class="iconfont icon-yanjing1"></i>
									<input type="text" v-model="code" placeholder="验证码">
									<sendCode :phone="phone" :isLogin="true"></sendCode>
								</li>
								<li class="pl40">
									<i class="iconfont icon-yanjing1"></i>
									<input type="password" v-model="password" placeholder="6 - 16位密码，区分大小写">
								</li>
								<li class="pl40">
									<i class="iconfont icon-yanjing1"></i>
									<input type="password"  v-model="password_confirmation" placeholder="确认密码">
								</li>
								<li class="borb0"><button class="loginBtn" @click="initPassword">重置密码</button></li>
							</ul>
						</div>
						<div class="tip">使用已有账户，<router-link to='/login'>登录</router-link></div>
					</div>
				</div>
			</el-main>
			<el-footer :style="{'height': footHeight + 'px'}">
				<elfooter></elfooter>
			</el-footer>
		</el-container>
	</div>
</template>
<script>
	import elheader from "../../components/loginHeader"; //头部
	import elfooter from "../../components/loginFooter"; //底部
    import sendCode from "../../components/sendCode"; //获取验证码
    import {checkedPhone,confirmPwd,checkPwd,checkedCodeEmpty} from "../../util/login";  //手机号码 密码验证
	export default {
		components: {
			elheader,
			elfooter,
            sendCode
		},
		data() {
			return {
				headHeight: 80,
				footHeight: 50,
				mainHeight: 0,
                phone:'',  //手机号
                code:'',  //验证码
                password:'',  //密码
                password_confirmation:'',  //重复密码
                isDisabled:true
			};
		},
		methods: {
            //重置密码
            initPassword(){
                var params={
                    phone:this.phone,
                    code:this.code,
                    password:this.password,
                    password_confirmation:this.password_confirmation
                }
                if (this.isDisabled&&document.getElementsByClassName('el-message').length === 0) {
                    this.isDisabled=false;
                    var isCheckedPhone=checkedPhone(this,this.phone);   //验证手机号码
                    if(isCheckedPhone){
                        var isCodeEmpty=checkedCodeEmpty(this,this.code)  //验证验证码  
                    }else{
                        this.isDisabled=true;
                        return false
                    }
                    if(isCodeEmpty){
                        var isCheckPwd=checkPwd(this,this.password);  //验证密码
                    }else{
                        this.isDisabled=true;
                        return false
                    }
                    if(isCheckPwd){
                        var isConfirmPwd=confirmPwd(this,this.password,this.password_confirmation);  //验证确认密码是否一致
                    }else{
                        this.isDisabled=true;
                        return  false
                    }
                    if(isConfirmPwd){
                        this.post(this, "/home/initPassword", params).then(res => {
                            if(res.data.code == 0) {
								this.$alert('恭喜您，密码修改成功！', '操作提示', {
									confirmButtonText: '返回登录'
								}).then(() => {
									window.localStorage.removeItem("pc_token");
									window.localStorage.removeItem("remembeLogin");
									window.localStorage.removeItem("level");
									window.localStorage.removeItem("ent_info");
									window.localStorage.removeItem("step");
									window.localStorage.removeItem("aside");
									window.localStorage.removeItem("asides");
									this.$router.push({ name: "login" });
								})
                            } 
                            this.isDisabled=true;
                        });
                    }else{
                        this.isDisabled=true;
                    }
                }
            },
		},
        mounted() {
			this.mainHeight =
				window.innerHeight -
				document.documentElement.querySelector(".el-header").clientHeight -
				document.documentElement.querySelector(".el-footer").clientHeight;
		},
	};
</script>
<style>
.el-message-box__headerbtn{
	display:none;
}
.el-button--primary{
	background:#ff7b00;
	border-color:#ff7b00;
	color: #fff;
}
.el-button:focus, .el-button:hover{
	background:#ff7b00;
	border-color:#ff7b00;
	color: #fff;
}
</style>
<style scoped>
	.el-header {
		line-height: 80px;
	}

	.el-footer {
		background: #3d3f41;
	}

	.el-main {
		background: url(../../public/img/login_bg.jpg) no-repeat center top;
		background-size: cover;
		padding: 80px 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.mid1200 {
		max-width: 1200px;
		margin: 0 auto;
	}

	.after:after {
		content: "";
		display: block;
		height: 0;
		clear: both;
		visibility: hidden;
	}

	.loginForm {
		margin: 0 auto;
		width: 610px;
	}

	.loginForm .title {
		font-weight: normal;
		color: #333;
		font-size: 24px;
		line-height: 2em;
		text-align: center;
		padding: 15px 0;
	}

	.formBox .form {
		background: #f7f7f7;
		border-bottom-left-radius: 2px;
		border-bottom-right-radius: 2px;
		overflow: hidden;
		padding: 0 35px 30px;
	}

	.formBox .form2 {
		background: #f7f7f7;
		border-bottom-left-radius: 2px;
		border-bottom-right-radius: 2px;
		overflow: hidden;
		padding: 20px 35px 30px;
	}

	.form li {
		padding: 15px 0;
		border-bottom: 1px solid #ddd;
		font-size: 18px;
		color: #999999;
		position: relative;
	}

	.form li.pl40 {
		padding-left: 40px;
	}

	.form li.pl95 {
		padding-left: 95px;
	}

	.form li.pr120 {
		padding-right: 120px;
	}

	.borb0 {
		border-bottom: 0 !important;
	}

	.form input {
		height: 40px;
		background: no-repeat;
		width: 100%;
		outline: 0;
	}

	.form li>i {
		font-size: 24px;
		position: absolute;
		left: 5px;
		top: 50%;
		margin-top: -12px;
	}

	.form li.forgetli {
		font-size: 16px;
		color: #333;
		padding: 30px 0;
	}

	.form li.phone_li span {
		color: #333333;
		font-size: 18px;
		height: 1em;
		line-height: 1em;
		position: absolute;
		left: 40px;
		top: 50%;
		margin-top: -.5em;
		border-right: 1px solid #333;
		padding-right: 10px;
		display: block;
	}

	.loginBtn {
		display: block;
		width: 100%;
		border-radius: 2px;
		background: #ff7b00;
		font-size: 24px;
		color: #fff;
		letter-spacing: 5px;
		height: 60px;
		margin-top: 30px;
	}

	.tip {
		margin-top: 30px;
		text-align: center;
		color: #fff;
		font-size: 16px;
	}

	.tip a {
		color: #ff7b00;
		cursor: default;
	}
	
</style>
<style>
	.passback .avatar-uploader{
		width: 120px;
		height: 120px;
	}
	.passback .avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 10px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		width: 120px;
		height: 120px;
		background: #fff;
	}
	.passback .avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}
	.passback .avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 120px;
		height: 120px;
		line-height: 120px;
		text-align: center;
	}
	.passback .avatar {
		width: 120px;
		height: 120px;
		display: block;
	}
</style>


